/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  function checkHeight() {
    if (window.innerWidth > window.innerHeight) {
      $("#hero_height").attr("uk-height-viewport");
      $("#hero_height").css("min-height", "100vh");
    } else {
      $("#hero_height").removeAttr("uk-height-viewport");
      $("#hero_height").css("min-height", "");
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Routes = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
        var menu = document.querySelector(".menu");
        if (menu) {
          var btn = menu.querySelector(".nav-tgl");
          btn.addEventListener("click", function (evt) {
            if (menu.className.indexOf("active") === -1) {
              menu.classList.add("active");
            } else {
              menu.classList.remove("active");
            }
          });
        }

        $("section").each(function (i, section) {
          var position = 400;
          $(
            "#" +
              $(section).attr("id") +
              ' div[uk-scrollspy*="cls: uk-animation"]'
          ).each(function (j, item) {
            $(item).css("animation-delay", position + "ms");
            position += 200;
          });
        });

        $(".module__gallery__container.swiper-container.g").each(function (
          index,
          item
        ) {
          var loop = false;
          if ($(item).data("swiper-loop")) {
            loop = $(item).data("swiper-loop");
          }
          var mySwiper = new Swiper(item, {
            watchOverflow: true,
            slidesPerView: "auto",
            loopedSlides: 10,
            spaceBetween: 20,
            centeredSlides: true,
            loop: loop,
            parallax: true,
            pagination: {
              el: ".swiper-pagination",
              type: "bullets",
              dynamicBullets: true,
              clickable: true,
            },
            on: {
              init: function () {
                $(item).height($(item).height() + 30);
              },
            },
          });
        });

        // Header Logo
        UIkit.util.on("header.site-header", "active", function () {
          $(".logo_top").addClass("uk-hidden");
          $(".logo_sticky").removeClass("uk-hidden");
        });

        // Header Logo
        UIkit.util.on("header.site-header", "inactive", function () {
          $(".logo_top").removeClass("uk-hidden");
          $(".logo_sticky").addClass("uk-hidden");
        });

        if (
          $(".top-bar").length &&
          $("header.site-header").hasClass("has_hero")
        ) {
          $("header.site-header").addClass("has_top-bar");
        }

        //Inputs
        //Selects using Choices.js
        if (!$("body").hasClass("single-investment-teaser")) {
          $("select").each(function (index, select) {
            if ($(select).attr("id") !== "group-type-order-by") {
              new Choices(select, {
                placeholder: true,
                placeholderValue: "This is a placeholder",
              });
            }
          });
        }

        //Material Design to inputs
        var inputs = document.querySelectorAll("input[type=text], textarea");
        inputs.forEach(function (element, index) {
          if (document.querySelector('label[for="' + inputs[index].id + '"]')) {
            if (element.value !== "") {
              document
                .querySelector('label[for="' + inputs[index].id + '"]')
                .classList.add("focused");
              document
                .querySelector('label[for="' + inputs[index].id + '"]')
                .classList.add("filled");
              element.classList.add("focused");
              element.classList.add("filled");
            }
            element.onfocus = function () {
              document
                .querySelector('label[for="' + inputs[index].id + '"]')
                .classList.add("focused");
              element.classList.add("focused");
            };
            element.onblur = function () {
              if (element.value === "") {
                document
                  .querySelector('label[for="' + inputs[index].id + '"]')
                  .classList.remove("focused");
                element.classList.remove("focused");
                element.classList.remove("filled");
              }
            };
            $(element).on("change paste keyup", function () {
              if (element.value === "") {
                element.classList.remove("filled");
                document
                  .querySelector('label[for="' + inputs[index].id + '"]')
                  .classList.remove("filled");
              } else {
                document
                  .querySelector('label[for="' + inputs[index].id + '"]')
                  .classList.add("filled");
                element.classList.add("filled");
              }
            });
          }
        });

        /* if ($('header').hasClass('has_hero')) {
          $('.uk-sticky-placeholder').each(function (i, el) {
            setTimeout(function () { $(el).css('display', 'none') }, 1000);
          });
        } */

        /* checkHeight();
        $(window).resize(function () {
          checkHeight();
        }); */

        $(".video_plyr").each(function (i, el) {
          if ($(this).data("autoplay") == "") {
            var video_player = new Plyr(el, {
              // controls: [],
              loadSprite: true,
              clickToPlay: true,
            });
          } else {
            var video_player = new Plyr(el, {
              muted: true,
              controls: [],
              loop: { active: true },
              loadSprite: false,
              clickToPlay: false,
              fullscreen: { enabled: false, fallback: false, iosNative: false },
              keyboard: { focused: false, global: false },
            });

            if (video_player.ready) {
              video_player.play();
            }
            $(document).on("scroll", function () {
              if (video_player.ready && !video_player.playing) {
                video_player.play();
              }
            });
            video_player.on("ready", function () {
              if (!video_player.playing) {
                $("html, body").animate(
                  {
                    scrollTop: document.documentElement.scrollTop - 1,
                  },
                  500
                );
              }
            });
          }
        });

        $(document).ready(function () {
          var navbar = $("nav.private__dashboard__sidebar__nav ul");
          UIkit.nav(navbar, {
            targets: "> .menu-item-has-children",
            multiple: false,
          });

          $("nav.private__dashboard__sidebar__nav li").each((i, el) => {
            if ($(el).hasClass("current-menu-ancestor")) {
              setTimeout(function () {
                $(el).addClass("uk-open");
                $(el).children("ul.sub-menu").removeAttr("hidden");
              }, 10);
            }
          });
        });

        if (window.gform) {
          gform.addFilter(
            "gform_file_upload_markup",
            function (html, file, up, strings, imagesUrl) {
              var formId = up.settings.multipart_params.form_id,
                fieldId = up.settings.multipart_params.field_id;
              html =
                "<strong>" +
                file.name +
                "</strong> <span class='delete_icon' onclick='gformDeleteUploadedFile(" +
                formId +
                "," +
                fieldId +
                ", this);' title='" +
                strings.delete_file +
                "'><i class='fas fa-trash-alt'></i></span>";

              return html;
            }
          );
        }

        if ($(".bb-signup-field.signup_password")) {
          $("#signup_password").val("aaa123");
          $("#signup_password_confirm").val("aaa123");
          $(".bb-signup-field.signup_password").hide();
          $(".bb-signup-field.signup_password_confirm").hide();
        }

        $("#signup-form").submit(function () {
          var a = grecaptcha.getResponse();
          if(a) {
            return true;
          } else {
            alert('Please verify that you are not a robot');
            return false;
          }
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
    change_avatar: {
      init: function () {
        var el = $(".profile.change-avatar")[1];
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $(el).offset().top,
          },
          1000
        );
      },
    },
    apply_here: {
      init: function () {
        var limit = 3;
        $(".max-3-checkbox ul.gfield_checkbox input").on(
          "change",
          function (evt) {
            if (
              $(".max-3-checkbox ul.gfield_checkbox input:checked").length >
              limit
            ) {
              this.checked = false;
            }
          }
        );
      },
    },
    groups: {
      init: function () {
        $("#bp-add-document").click(function () {
          setTimeout(function () {
            var span = $("#media-uploader span")[0];
            $(span).html("Click here or drop images to upload");
          }, 50);
        });
      },
    },
    single_marketplace: {
      init: function () {
        var swipper = new Swiper("#marketplace-swiper", {
          autoHeight: true,
          watchOverflow: true,
          slidesPerView: 1,
          loopedSlides: 10,
          spaceBetween: 20,
          loop: true,
          centeredSlides: true,
          parallax: true,
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            dynamicBullets: true,
            clickable: true,
          },
        });

        UIkit.util.on("#switcher", "show", function (e) {
          if (e.target.id === "meeting") {
            $(e.target).find(".responsive-whereby").css("display", "block");
          } else {
            $("#meeting").find(".responsive-whereby").css("display", "none");
          }
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && Routes[func];
      fire = fire && typeof Routes[func][funcname] === "function";

      if (fire) {
        Routes[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
